<template>
    <div>
        <van-field
            name="agency"
            :rules="[{ validator:validator2, message: '请选择机构' }]"
            label="所属机构">
            <template #input>
                <div class="select">
                    <div class="select-item" @click="openPicker(1)">
                        <div class="text" :class="{'empty':agencySelectList.name == ''}">
                            <span>{{ agencySelectList.name || '请选择' }}</span>
                        </div>
                        <div class="icon-list">
                            <van-icon name="arrow-down" :class="{'rotate':selectLevel === 1 && showPicker}"/>
                        </div>
                    </div>
                    <!--                二级-->
                    <div class="select-item" v-if="showLevel > 1 && agancyFilterList.length > 0" @click="openPicker(2)">
                        <div class="text" :class="{'empty':agencySelectList.child.name == ''}">
                            <span>{{ agencySelectList.child.name || '请选择' }}</span>
                        </div>
                        <div class="icon-list">
                            <van-icon name="arrow-down" :class="{'rotate':selectLevel === 2 && showPicker}"/>
                        </div>
                    </div>
                    <!--                三级-->
                    <div class="select-item" v-if="showLevel > 2 && agancyFilterList.length > 0" @click="openPicker(3)">
                        <div class="text" :class="{'empty':agencySelectList.child.child.name == ''}">
                            <span>{{ agencySelectList.child.child.name || '请选择' }}</span>
                        </div>
                        <div class="icon-list">
                            <van-icon name="arrow-down" :class="{'rotate':selectLevel === 3 && showPicker}"/>
                        </div>
                    </div>
                </div>
            </template>
        </van-field>
        <portal to="destination">
            <van-popup v-model:show="showPicker" position="bottom" ref="popup">
                <div class="updown-select">
                    <div class="updown-item"
                         :class="{'active':activeId(item.id)}"
                         v-for="(item,index) in popList"
                         :key="item.id"
                         @click="confirmAgency(item)">
                        {{ item.name }}
                    </div>
                </div>
            </van-popup>
        </portal>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: []
        },
        value: {
            required: true
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },

    data() {
        return {
            popList: [], //列表值
            showPicker: false,
            selectLevel: 1,//当前选中机构
            showLevel: 1, //大于1展示2和3级，
            agencySelectList: {
                name: '',
                id: 0,
                child: {
                    name: '',
                    id: 0,
                    child: {
                        name: '',
                        id: 0
                    }
                }
            },

        }
    },
    computed: {
        fromData: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        agancyFilterList() {
            if (this.selectLevel === 1) {
                return this.list
            } else if (this.selectLevel === 2) {
                //筛选二级
                return this.getChildList(this.list, [this.agencySelectList.id])

            } else if (this.selectLevel === 3) {
                //筛选三级
                let secrodId = 0
                if (this.agencySelectList.child) {
                    secrodId = this.agencySelectList.child.id || 0
                }
                return this.getChildList(this.list, [this.agencySelectList.id, secrodId])
            } else {
                return this.popList
            }
        }

    },
    methods: {
        activeId(id) {
            let id_1 = this.agencySelectList.id
            let id_2 = (this.agencySelectList.child || {}).id || 0
            let id_3 = (this.agencySelectList.child.child || {}).id || 0
            return [id_1, id_2, id_3].includes(id)
        },
        validator2() {
            if (!this.agencySelectList.id) {
                return false
            } else if (this.showLevel === 2 && this.agencySelectList.child && this.agencySelectList.child.id === 0) {
                return false
            } else if (this.showLevel === 3 && this.agencySelectList.child && this.agencySelectList.child?.child.id === 0) {
                return false
            } else {
                return true
            }
        },
        openPicker(index) {
            this.showPicker = true
            this.selectLevel = index
        },
        // 选中机构
        confirmAgency(data) {
            if (this.selectLevel === 1) {
                this.agencySelectList.name = data.name
                this.agencySelectList.id = data.id
                this.agencySelectList.child = {
                    id: 0,
                    name: ''
                }
                if (data.child) {
                    this.showLevel = 2
                    if (data.child.length === 1) {
                        this.autoSetAgency(data.child[0], 2)
                    }
                } else {
                    this.showLevel = 1
                }
            } else if (this.selectLevel === 2) {
                //选中二级
                if (this.agencySelectList.child) {
                    this.agencySelectList.child.name = data.name
                    this.agencySelectList.child.id = data.id
                    this.agencySelectList.child.child = {
                        id: 0,
                        name: ''
                    }
                    if (data.child) {
                        this.showLevel = 3
                        if (data.child.length === 1) {
                            this.autoSetAgency(data.child[0], 3)
                        }
                    } else {
                        this.showLevel = 2
                    }
                }
            } else if (this.selectLevel === 3) {
                //选中三级
                if (this.agencySelectList.child && this.agencySelectList.child.child) {
                    this.agencySelectList.child.child.name = data.name
                    this.agencySelectList.child.child.id = data.id
                }
            }
            this.fromData = this.agencySelectList
            this.showPicker = false
        },
        autoSetAgency(data, index) {
            this.selectLevel = index
            this.confirmAgency(data)

        },
        getChildList(dataList, idList) {
            let data = []

            function getList(dataList, idList = []) {
                if (idList.length === 0) {
                    data = dataList
                    return data
                }
                let id = idList.shift()
                let list = dataList.find((item) => {
                    return item.id === id
                })
                if (list.child) {
                    getList(list.child, idList)
                } else {
                    return []
                }
            }

            getList(dataList, idList)
            return data
        }
    },
    watch: {
        showPicker() {
            if (this.showPicker) {
                this.popList = this.agancyFilterList
            }
        },
        agencySelectList() {
            this.$emit("resetValidation")
        },
        list(newValue, oldValue) {
            if (oldValue?.length === 0) {
                //当只有一个一级
                if (newValue?.length === 1) {
                    this.autoSetAgency(newValue[0], 1)
                }
            } else {
                if (newValue[0].id !== oldValue[0].id) {
                    this.autoSetAgency(newValue[0], 1)
                }
            }
        }
    },
}
</script>
<style scoped lang="less">
.select {
    width: 100%;

    .select-item {
        padding-bottom: 10px;
        border-bottom: 1px solid #e9ebef;
        position: relative;

        & + .select-item {
            margin-top: 10px;
        }

        .text {
            height: 24px;
            font-size: 16px;
            background-color: white;
            color: #232323;
            border: none;
            opacity: 1;
        }

        .empty {
            color: #c6c7cb;
        }

        .icon-list {
            position: absolute;
            right: 5px;
            top: 0px;
        }

        .van-icon {
            transition: all 0.3s;
        }
    }

    .rotate {
        transform: rotate(180deg);
    }
}

.updown-select {
    width: 100%;
    height: 35vh;
    overflow: auto;
    background-color: white;
    padding: 10px 0;

    .updown-item {
        width: 100%;
        font-size: 15px;
        padding: 15px 10px;
        box-sizing: border-box;

        &:hover {
            background-color: #94C1FF;
        }
    }

    .active {
        background-color: rgba(148, 193, 255, 0.2) !important;
        color: #3272dd;
        font-weight: 700;
    }
}
</style>